<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!disabled">Update Module</v-flex>
                    <v-flex v-else> Module List </v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                    </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">                
                        <v-flex>
                           <span style="font-size: 18px;font-weight: bold;"> Course Title : </span> 
                           <span> {{ Course_Title }} </span>
                        </v-flex>
                    </v-flex>
                    <v-flex v-if="disabled">
                        <v-radio-group v-model="Delete_Type" row>
                            <v-radio label="Modules" value="Modules"></v-radio>
                            <v-radio label="Study Material" value="Study_Material"></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex wrap style="padding: 10px;" v-if="Delete_Type == 'Modules'">
                        <v-layout v-for="(item , index) in Sections" :key="item.Section_Id" row>
                            <v-text-field :disabled='disabled' style="padding: 0px 10px;" :label="'Section '+ (index + 1)" v-model="item.Section_Title"></v-text-field>
                            <v-icon color='red' @click="DeleteSection(item)">delete</v-icon>
                        </v-layout>
                    </v-flex>
                    <v-flex wrap style="padding: 10px;" v-else>
                        <v-select item-value='Course_Id' item-text='name' return-object v-model="SelectedSection" :items="Sections" label="Select Section" @change="GetDetailsSectionList">
                            <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Section_Title }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                    {{ item.Section_Title }}    
                            </template>
                         </v-select>
                         <v-flex v-for="documents in Study_Material" :key="documents.Document_Id">
                            <v-layout>
                                <v-flex pa-2> 
                                    <a :href="documents.Document_URL" target="_blank">{{ documents.Document_URL }}</a>
                                    <v-icon @click="DeleteStudyMaterial(documents)" style="margin: 0px 12px;" color='error'>delete</v-icon>
                                </v-flex>
                            </v-layout> 
                         </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex v-if="!disabled" style="text-align: right;">
                        <v-btn color="success" @click="UpdateSection">Update Module</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Course_Title            : "",
            Sections                : [],
            Course_Details          : {},
            disabled                : false,
            Delete_Type             : 'Modules',
            SelectedSection         : {},
            Study_Material          : [],
        }
    },
    methods:{
        CloseDialog(){

            this.Course_Title    = ""
            this.Sections        = []
            this.Course_Details  = {}
            this.disabled        = false
            this.Delete_Type     = 'Modules'
            this.SelectedSection = {}
            this.Study_Material  = []
            this.$emit('close')
        },
        GetSection(Course,Type){
            
            this.Course_Title   = Course["Course_Title"]
            this.Course_Details = Course
            this.disabled       = Type == 'Update' ? false : true
            let data = {}
            data["Course_Id"] = Course["Course_Id"]
            this.Sections = Course["Course_Curriculam"]
        },
        UpdateSection(){

            let data = {}
            data["Course_Id"]        = this.Course_Details["Course_Id"]
            data["Sections"]         = this.Sections

            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/updatesections`,data)
                        .then(response =>{

                            this.$store.commit('SetCourseCurriculamList',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Section","Color":"green","Close": false });
                            this.CloseDialog()

                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Section","Color":"red","Close": false });
                        })

        },
        DeleteSection(item){

            let data = {}
            data["Course_Id"]        = this.Course_Details["Course_Id"]
            data["Section_Id"]       = item['Section_Id']
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/deletesections`,data)
                        .then(response =>{
                            
                            this.$store.commit('SetCourseCurriculamList',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Delete Section","Color":"green","Close": false });
                            this.CloseDialog()

                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Delete Section","Color":"red","Close": false });
                        })
        },
        GetDetailsSectionList(){
            this.Study_Material = this.SelectedSection['Study_Materials'] ? this.SelectedSection['Study_Materials'] : []
        },
        DeleteStudyMaterial(documents){
            let data = {
                'Course_Id'    : this.Course_Details['Course_Id'],
                'Section_Id'   : this.SelectedSection['Section_Id'],
                'Document_Id'  : documents['Document_Id']
            }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/deletemodulestudymaterial`,data)
                    .then(response =>{
                        
                        this.$store.commit('SetCourseCurriculamList',response["data"]["response"])   
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Deleted File","Color":"green","Close": false });  
                        this.CloseDialog()
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Delete File","Color":"red","Close": false });
                    })
        } 
    }
}
</script>
<style scoped>

</style>